import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  VStack,
} from "@chakra-ui/react";
import { endOfMonth, endOfYear, format, subMonths, subYears } from "date-fns";
import React, { useEffect, useState } from "react";
import { updateCustomerBulk } from "../../api/customers";
import { updateTargetsBulk } from "../../api/customerCustomTargets";

const predefinedOptions = [
  { label: "Last Month", value: "last_month" },
  { label: "Year-to-date", value: "year_to_date" },
  { label: "Last Year", value: "last_year" },
];

const getMonthOptions = () => {
  const options = [];
  const now = new Date();
  for (let i = 0; i < 12; i++) {
    const monthDate = subMonths(now, i);
    options.push({
      label: format(monthDate, "MMMM yyyy"),
      value: format(monthDate, "yyyy-MM"),
    });
  }
  return options;
};

const getEndDate = (value) => {
  const now = new Date();
  if (value === "last_month") return endOfMonth(subMonths(now, 1));
  if (value === "year_to_date") return endOfMonth(now);
  if (value === "last_year") return endOfYear(subYears(now, 1));

  // If value is yyyy-MM
  if (/^\d{4}-\d{2}$/.test(value)) {
    const parsed = new Date(`${value}-01`);
    return endOfMonth(parsed);
  }

  return null;
};

const BulkCalendarComponent = ({
  selectedIds = [],
  customerList,
  setCustomerList,
  triggerSetter = null,
}) => {
  const [selected, setSelected] = useState("last_month");
  const [monthOptions, setMonthOptions] = useState(getMonthOptions());

  useEffect(() => {
    setMonthOptions(getMonthOptions());
  }, []);

  const handleSelect = async (value) => {
    const endDate = getEndDate(value);
    if (!endDate || selectedIds.length === 0) return;

    setSelected(value);
    const formatted = format(endDate, "yyyy-MM-dd");

    try {
      await updateCustomerBulk({
        ids: selectedIds,
        dashboard_date: formatted,
      });
      await updateTargetsBulk({
        customer_ids: selectedIds,
        dashboard_date: formatted,
      });

      const updated = customerList.map((cust) =>
        selectedIds.includes(cust.id) ? { ...cust, dashboard_date: formatted } : cust
      );
      setCustomerList(updated);
      triggerSetter && triggerSetter(true);
    } catch (err) {
      console.error("Bulk update failed", err);
    }
  };

  const getStyles = (isSelected) => ({
    bg: isSelected ? "#536DEC" : "white",
    color: isSelected ? "white" : "black",
    fontWeight: "normal",
    borderRadius: "8px",
    _hover: {
      color: isSelected ? "white" : "#536DEC",
      bg: isSelected ? "#536DEC" : "white",
    },
    _focus: { bg: isSelected ? "#536DEC" : "white" },
  });

  return (
    <Box display="inline-block" zIndex={1000}>
      <Menu>
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          width="auto"
          bg="white"
          color="black"
          border="1px solid #D1D4DA"
          _hover={{ border: "1px solid #536DEC" }}
          _expanded={{ border: "1px solid #536DEC" }}
        >
          {format(getEndDate(selected), "MMM yyyy")}
        </MenuButton>

        <MenuList width="210px" p={2}>
          <VStack align="start" spacing={1}>
            {predefinedOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                {...getStyles(selected === opt.value)}
                onClick={() => handleSelect(opt.value)}
              >
                {opt.label}
              </MenuItem>
            ))}
            <Box borderTop="1px solid #E2E8F0" my={1} width="100%" />
            {monthOptions.map((opt) => (
              <MenuItem
                key={opt.value}
                {...getStyles(selected === opt.value)}
                onClick={() => handleSelect(opt.value)}
              >
                {opt.label}
              </MenuItem>
            ))}
          </VStack>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default BulkCalendarComponent;
